import { Box, Button, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import LyfPaymentIntentInfos from '../../my-lemonade-library/src/payments/models/lyf/LyfPaymentIntentInfos';

interface PaymentLyfRedirectProps {
    paymentInfos: LyfPaymentIntentInfos;
    returnHomePage: () => void;
}

const PaymentLyfRedirect: React.FC<PaymentLyfRedirectProps> = ({
    paymentInfos,
    returnHomePage
}) => {
    const intl = useIntl();
    const theme = useTheme();

    useEffect(() => {
        if (paymentInfos.payment_url && window.top) {
            window.top.location.href = paymentInfos.payment_url;
        } else {
            returnHomePage();
        }
    }, [paymentInfos, returnHomePage]);

    return (
        <Box
            py={3}
            px={5}
            width="100%"
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
        >
            <Box
                flex={1}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    mt={4}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                >
                    <Typography variant="h2" color="textSecondary">
                        {intl.formatMessage({ id: "payments.page.redirect_payment" })}
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="contained"
                color="primary"
                style={{
                    marginTop: theme.spacing(3),
                    textTransform: "none",
                }}
                onClick={returnHomePage}
            >
                <Typography>
                    {intl.formatMessage({ id: "returnHomePage" }, { br: <br /> })}
                </Typography>
            </Button>
        </Box>
    );
};

export default PaymentLyfRedirect;